export const moduleSlug = "CONFIG_CI";

export default { moduleSlug };
